import { render, staticRenderFns } from "./permission-management.vue?vue&type=template&id=73a1ef9a&scoped=true"
import script from "./permission-management.vue?vue&type=script&lang=js"
export * from "./permission-management.vue?vue&type=script&lang=js"
import style0 from "./permission-management.vue?vue&type=style&index=0&id=73a1ef9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1ef9a",
  null
  
)

export default component.exports